var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyTable = function SvgEmptyTable(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 180,
    viewBox: "0 0 232 180",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-table_svg__clip0_18395_59719)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.585 1.535C49.483-11.495 27.481 61.805 45.725 97.481c10.581 20.69-39.64 70.792 17.744 81.468 27.538 5.123 36-13.341 62.433-10.655 35.4 3.6 148.167-4.73 88.349-78.915-31.713-39.335 1.026-79.506-63.666-87.844z",
    fill: "#F5F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.069 136.51l-.654 4.238-1.27-5.38a58.934 58.934 0 00-11.462-4.965l-.083 5.636-2.545-6.393a55.094 55.094 0 00-13.655-1.854l.704 6.178-3.356-6.108c-4.151.183-8.256.946-12.195 2.268l2.33 3.525s-2.173-1.597-4.084-2.896a40.951 40.951 0 00-10.833 6.285 85.492 85.492 0 0012.575 10.527c2.482-.637 5.127-1.279 5.127-1.279l-3.261 2.537a69.366 69.366 0 0013.283 6.865c2.346-1.353 5.416-3.269 5.416-3.269l-3.554 3.931a42.226 42.226 0 0015.45 2.359l4.259-4.213-1.697 4.001c7.002-.848 14.144-3.902 20.95-10.344-1.621-3.869-5.768-8.073-11.445-11.649z",
    fill: "#9BDEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.557 136.978a.413.413 0 01.475-.342l68.549 11.118a.414.414 0 01-.133.817L.9 137.453a.415.415 0 01-.342-.475z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.887 125.586h-88.1c-2.752 0-5.38-2.234-5.38-4.986V27.534c0-2.752 2.644-4.966 5.38-4.966h88.1c2.752 0 5.4 2.23 5.4 4.966V120.6c0 2.752-2.632 4.986-5.4 4.986z",
    fill: "#9BDEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.786 22.982c-2.55 0-4.965 2.07-4.965 4.552V120.6c0 2.484 2.4 4.572 4.965 4.572h88.101c2.582 0 4.986-2.089 4.986-4.572V27.534c0-2.464-2.418-4.552-4.986-4.552h-88.1zm-5.793 4.552c0-3.022 2.874-5.38 5.793-5.38h88.101c2.935 0 5.814 2.374 5.814 5.38V120.6c0 3.021-2.86 5.4-5.814 5.4h-88.1c-2.94 0-5.794-2.381-5.794-5.4V27.534z",
    fill: "#1D1E26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty-table_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 22,
    width: 100,
    height: 104
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.887 125.586h-88.1c-2.752 0-5.38-2.234-5.38-4.986V27.534c0-2.752 2.644-4.966 5.38-4.966h88.1c2.752 0 5.4 2.23 5.4 4.966V120.6c0 2.752-2.632 4.986-5.4 4.986z",
    fill: "#9BDEFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty-table_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.817 99.247a.414.414 0 01.585-.003l50.88 50.483a.414.414 0 01-.583.588l-50.88-50.483a.414.414 0 01-.002-.585zM72.802 28.407a.414.414 0 01.553.192l63.6 131.172a.413.413 0 11-.745.361L72.61 28.96a.414.414 0 01.192-.553z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.576 6.515a.415.415 0 01.087.58L60.185 118.817a.413.413 0 11-.665-.491L141.997 6.603a.414.414 0 01.579-.088zM197.977 60.314c.181.14.214.4.075.58l-76.734 99.311a.414.414 0 01-.655-.506l76.734-99.31a.413.413 0 01.58-.075zM192.316 43.44a.413.413 0 01-.103.576L60.089 135.878a.414.414 0 01-.473-.68L191.74 43.336a.414.414 0 01.576.104z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.966 11.532a.414.414 0 01.585-.021l129.252 120a.414.414 0 01-.563.606l-129.252-120a.414.414 0 01-.022-.585zM75.232 2.769a.414.414 0 01.568.143l93.554 156.828a.414.414 0 11-.711.424L75.089 3.336a.414.414 0 01.143-.567zM125.643.329a.414.414 0 01.584.041l71.81 82.759a.413.413 0 11-.625.542L125.602.913a.414.414 0 01.041-.584z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.271 75.369a.414.414 0 01.547-.209l156.745 70.345a.413.413 0 11-.339.755L67.479 75.916a.414.414 0 01-.208-.547z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.279 8.938a.414.414 0 01.265.522L101.278 187.39a.413.413 0 11-.787-.258l58.266-177.93a.414.414 0 01.522-.265z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.786 22.982c-2.55 0-4.965 2.07-4.965 4.552V120.6c0 2.484 2.4 4.572 4.965 4.572h88.101c2.582 0 4.986-2.089 4.986-4.572V27.534c0-2.464-2.418-4.552-4.986-4.552h-88.1zm-5.793 4.552c0-3.022 2.874-5.38 5.793-5.38h88.101c2.935 0 5.814 2.374 5.814 5.38V120.6c0 3.021-2.86 5.4-5.814 5.4h-88.1c-2.94 0-5.794-2.381-5.794-5.4V27.534z",
    fill: "#1D1E26"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.287 30.828H81.39v-3.724a4.966 4.966 0 014.966-4.966H175.3a4.963 4.963 0 014.986 4.965v3.725z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.05 22.893a4.548 4.548 0 00-1.748-.341H86.356a4.552 4.552 0 00-4.552 4.552v3.31h98.069v-3.31a4.55 4.55 0 00-2.823-4.211zm-1.75-1.169a5.375 5.375 0 014.989 3.316c.272.654.412 1.355.412 2.064v3.724a.414.414 0 01-.414.413H81.39a.414.414 0 01-.413-.413v-3.724a5.38 5.38 0 015.379-5.38H175.3z",
    fill: "#1D1E26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.324 28.217a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM93.597 28.217a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM99.866 28.217a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z",
    fill: "#1D1E26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.71 47.806H63.614a4.986 4.986 0 00-4.986 4.986v93.062a4.986 4.986 0 004.986 4.986h88.096a4.986 4.986 0 004.987-4.986V52.792a4.987 4.987 0 00-4.987-4.986z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.614 48.22a4.572 4.572 0 00-4.572 4.572v93.062a4.572 4.572 0 004.572 4.572h88.096a4.572 4.572 0 004.573-4.572V52.792a4.572 4.572 0 00-4.573-4.573H63.614zm-5.4 4.572a5.4 5.4 0 015.4-5.4h88.096a5.4 5.4 0 015.4 5.4v93.062a5.4 5.4 0 01-5.4 5.4H63.614a5.4 5.4 0 01-5.4-5.4V52.792z",
    fill: "#1D1E26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.11 56.081H58.214v-3.724a4.986 4.986 0 014.986-4.965h88.924a4.988 4.988 0 014.986 4.965v3.724z",
    fill: "#008ACE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.566 53.474a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM70.835 53.474a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zM77.103 53.474a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z",
    fill: "#1D1E26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.968 36.067a.414.414 0 01.585.018l7.005 7.448a.414.414 0 11-.603.567l-7.005-7.448a.414.414 0 01.018-.585zM46.99 44.047a.414.414 0 01.554-.188l6.269 3.104a.414.414 0 01-.367.742l-6.27-3.104a.414.414 0 01-.187-.554zM183.97 9.366a.414.414 0 01.213.545l-2.896 6.62a.414.414 0 01-.759-.331l2.897-6.621a.414.414 0 01.545-.213zM192.373 9.866a.415.415 0 010 .585l-8.276 8.276a.414.414 0 11-.585-.585l8.275-8.276a.415.415 0 01.586 0zM192.464 19.108a.413.413 0 01-.23.538l-6.207 2.483a.414.414 0 01-.308-.768l6.207-2.483a.414.414 0 01.538.23zM182.977 54.848c.228 0 .413.185.413.414v58.345a.414.414 0 11-.827 0V55.262c0-.229.185-.414.414-.414z",
    fill: "#1D1E26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.371 157.945c23.196 0 42-18.804 42-42s-18.804-42-42-42-42 18.804-42 42 18.804 42 42 42z",
    fill: "#008ACE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.371 149.669c18.625 0 33.724-15.099 33.724-33.724 0-18.625-15.099-33.724-33.724-33.724-18.625 0-33.724 15.099-33.724 33.724 0 18.625 15.099 33.724 33.724 33.724z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M117.312 113.565a3.807 3.807 0 100-7.614 3.807 3.807 0 000 7.614zM149.435 113.565a3.806 3.806 0 100-7.612 3.806 3.806 0 000 7.612z",
    fill: "#1D1E26"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.38 123.952c-4.592 0-8.525 2.259-10.468 5.423a.827.827 0 11-1.41-.866c2.27-3.697 6.762-6.212 11.878-6.212 5.108 0 9.646 2.485 11.882 6.22a.827.827 0 11-1.42.85c-1.902-3.176-5.863-5.415-10.462-5.415z",
    fill: "#1D1E26"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.965 137.356l-7.822 9.777 1.668 1.334 7.822-9.777-1.668-1.334z",
    fill: "#1D1E26"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M200.774 163.345c.579 2.143-3.331 6.852-5.553 6.939-7.035.277-28.73-23.913-28.73-23.913l4.44-5.553s28.122 16.142 29.843 22.527z",
    fill: "#9BDEFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M204.424 178.378a6.223 6.223 0 006.223-6.224 6.224 6.224 0 10-6.223 6.224z",
    fill: "#9BDEFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M199.586 168.269a6.173 6.173 0 013.311-2.131l-2.123-1.697c-.464 2.069-2.959 4.995-4.837 5.69l2.296 1.837a6.173 6.173 0 011.353-3.699z",
    fill: "#1D1E26"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.357 138.314l-3.5 2.955 2.722-5.317a67.379 67.379 0 00-5.958-12.509l-4.014 4.514 2.38-7.076a63.412 63.412 0 00-9.932-11.611l-3.724 5.549 1.54-7.448a50.152 50.152 0 00-11.628-7.179l-.567 4.605s-.675-2.896-1.333-5.38a44.62 44.62 0 00-13.315-2.896 96.722 96.722 0 002.983 17.856c2.483 1.311 5.119 2.751 5.119 2.751l-4.461-.347a79.474 79.474 0 006.091 15.385c2.897.637 6.745 1.353 6.745 1.353l-5.677.55c2.871 4.965 6.492 9.6 11.069 13.349l6.45-.269-4.191 1.99c6.356 4.49 14.37 7.3 24.48 7.105 1.398-4.332.902-10.816-1.279-17.93z",
    fill: "#008ACE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.73 96.184a.414.414 0 01.581.06l48.646 59.751a.413.413 0 11-.642.523L24.67 96.766a.414.414 0 01.06-.582z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-table_svg__clip0_18395_59719"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.552)",
    d: "M0 0h230.897v180H0z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "9d07e940a696e0f6b75f1295336e795f.svg";
export { ForwardRef as ReactComponent };